export const EMAIL = "melanciafilmes@outlook.com";
export const INSTAGRAM_URL = "https://www.instagram.com/melancia.filmes/";
export const NUMBER_OF_PROJECTS_IN_HOME = 6;
